import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger';
  showHeader?: boolean;
  showCancel?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  showHeader = true,
  showCancel = true
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="sm" centered>
      {showHeader && (
        <ModalHeader toggle={onClose}>
          {title}
        </ModalHeader>
      )}
      <ModalBody>
        {message}
      </ModalBody>
      <ModalFooter>
        {showCancel && (
          <Button
            color="secondary"
            onClick={onClose}
          >
            {cancelText}
          </Button>
        )}
        <Button
          color={confirmVariant}
          onClick={handleConfirm}
          style={{
            backgroundColor: '#ff697f',
            borderColor: '#ff697f'
          }}
        >
          {confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationDialog;